/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Text, theme } from "@nordcloud/gnui";
import { Pagination, ReactTable } from "~/components";
import { EstateData } from "./EstateData";
import { CommonListProps } from "./types";

type ResourcesListProps = {
  metadata: CommonListProps;
};

export function ResourcesList({ metadata }: ResourcesListProps) {
  return (
    <If condition={metadata.hasResources}>
      <Then>
        <EstateData
          currentMonthTotal={metadata.data?.cost?.currentMonthTotal}
          count={metadata.data?.count}
        />
        <ReactTable
          striped
          columns={metadata.columns}
          data={metadata.rows}
          sort={false}
        />
        {metadata.showPagination && <Pagination count={metadata.estateCount} />}
      </Then>
      <Else>
        <Text py={theme.spacing.spacing04}>
          No resources matching selected criteria
        </Text>
      </Else>
    </If>
  );
}
